// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"6f395b1b","489":"c6318684","645":"ccaedc5c","702":"3f19f2fe","787":"47315339"}[chunkId] + ".chunk.js";
};